'use strict';

import {createElWithAttrs} from '@borngroup/born-utilities';

let loaderEl,
    loaderIndicator,
    loaderGroupFace,
    loaderGroupEyes,
    loaderClip,
    loaderClipDefs,
    loaderClipPath,
    clipPathValue;

// element level spinner:
$.fn.spinner = function() {
    let element = this,
        Fn = function() {
            this.start = showLoader.bind(this, element);
            this.stop = hideLoader;
        };

    return new Fn();
};

// page-level spinner:
$.spinner = function() {
    let Fn = function() {
        this.start = showLoader;
        this.stop = hideLoader;
    };

    return new Fn();
};

/**
 * @function
 * @description Shows an AJAX-loader on top of a given containerEl
 * @param {Element} containerEl The Element on top of which the AJAX-Loader will be shown
 */
export function showLoader(containerEl, setAlt, message) {
    let matchedContainerEl = (typeof containerEl === 'string' ? document.querySelector(containerEl) : containerEl) || false,
        targetEl = matchedContainerEl instanceof HTMLElement ? matchedContainerEl : document.body;

    loaderEl = loaderEl || document.querySelector('.loader');

    //Render a loading SVG.
    //Animation is controlled through CSS.
    //This prevents having to wait for the loader to render before displaying it.
    if (!loaderEl) {
        clipPathValue = 'M57.89,40.39l-7.18-5,3.71-6.73h0L59.74,19l.93,4.89Zm-6.1,8.74L40.52,39.45,50,36.06l7.55,5.31ZM32.32,70c-5.08-.21-7.21-2.8-7.88-3.88l7.83-2.74,7.81,2.73C37.29,69.93,32.35,70,32.32,70ZM3.92,23.86l.93-4.92,5.33,9.67h0l3.72,6.73-7.2,5ZM1.09,4.65a.43.43,0,0,0,0-.12,3,3,0,0,1,.54-1.08C5.15,1.07,13.33,6.76,16.85,9.67l-12,7.1C.09,7.14,1.09,4.66,1.09,4.65Zm15.13.11L17,8.47C14.75,6.71,9.68,3,5.44,2.07c4.09,0,9.62,2.2,10.78,2.69ZM34.05,1c.09,0,5.51,0,13.27,3.67L42.55,31,32.8,28V1c.42,0,.83,0,1.25,0ZM59.23,2.08C55,3,49.8,6.79,47.64,8.52l.68-3.74C49.4,4.32,55.09,2,59.23,2.08ZM53.65,28l-10.07,3,3.7-20.39,12,7.14ZM21.6,32l2.53,6.39L14.9,35.09l-3.26-5.91Zm-.26-1.12L11,28,5.29,17.67l12.06-7.14ZM31.8,28l-9.44,3L17.23,4.7A49.12,49.12,0,0,1,31.8,1.07Zm1,8.53V29.05l9.46,2.88-3,6.72Zm-7.3,3.09,6.8-2.2L39,39.63V53.41H25.5Zm6.3-3.09-6.51,2.1-2.66-6.71,9.17-2.88Zm.49,22.3-5.81-4.43H38.07ZM7.05,41.35l7.57-5.29L24,39.44,12.79,49.11ZM13.25,50,24.5,40.35V53.61L15,58.71ZM23.8,65.28l-8.25-5.75,9.4-5,6.85,5.22v2.77Zm17,0-8-2.79V59.72l6.79-5.22,9.45,5Zm8.85-6.58L40,53.61V40.35l11.29,9.71Zm.08-23.62L40.48,38.4,43.31,32,53,29.19Zm10-18.32L47.82,9.67C51.3,6.76,59.43,1.1,62.92,3.46a3,3,0,0,1,.53,1.07l0,.1s1,2.51-3.73,12.14Zm.74.79c4.9-9.87,4.14-12.8,3.9-13.33a3.72,3.72,0,0,0-.69-1.36.22.22,0,0,0-.05-.08,3.92,3.92,0,0,0-1.41-1.11C58-.32,49.44,3.21,47.94,3.85,39.82,0,34.3,0,34.05,0,33.51,0,33,0,32.42,0L32.3,0a.58.58,0,0,0-.19,0A48.54,48.54,0,0,0,16.66,3.86C15.18,3.22,6.56-.32,2.34,1.68A4.16,4.16,0,0,0,.92,2.79l0,0a3.86,3.86,0,0,0-.71,1.4c-.24.53-1,3.46,3.9,13.32L2.92,23.76a.49.49,0,0,0,0,.17L5.84,41.31h0a.39.39,0,0,0,.08.2h0L12.24,50l1.87,9.53a.15.15,0,0,0,0,.07.64.64,0,0,0,0,.07h0a.43.43,0,0,0,.14.16l9,6.29c.39.79,2.58,4.56,9,4.83.24,0,5.94,0,8.94-4.81l9-6.31a.54.54,0,0,0,.14-.16h0a.1.1,0,0,0,0-.07.21.21,0,0,0,0-.07L52.35,50l6.31-8.51a.85.85,0,0,0,.09-.22l2.92-17.38a.49.49,0,0,0,0-.17Z'

        loaderEl = createElWithAttrs(false, {class: 'loader face-loader-wrapper'});
        loaderIndicator = createElWithAttrs(loaderEl, {'class': 'loader-indicator'}, {tagName: 'svg', nameSpace: 'svg'});
        loaderGroupFace = createElWithAttrs(loaderIndicator, {'class': 'face'}, {tagName: 'g', nameSpace: 'svg'});
        loaderGroupEyes = createElWithAttrs(loaderIndicator, {'class': 'eyes'}, {tagName: 'g', nameSpace: 'svg'});
        loaderClip = createElWithAttrs(loaderEl, {'class': 'hide'}, {tagName: 'svg', nameSpace: 'svg'});
        loaderClipDefs = createElWithAttrs(loaderClip, {}, {tagName: 'defs', nameSpace: 'svg'});
        loaderClipPath = createElWithAttrs(loaderClipDefs, {id: 'clipping-face'}, {tagName: 'clipPath', nameSpace: 'svg'});

        //Manage the look and feel of your loader here.
        createElWithAttrs(
            loaderClipPath, {
                d: clipPathValue
            },
            {tagName: 'path', nameSpace: 'svg'}
        );
        createElWithAttrs(
            loaderEl, {
                class: 'face-loader face-loader--reverse'
            },
        );
        createElWithAttrs(
            loaderGroupEyes, {
                id: 'eye-sx',
                points: '14.9 35.09 11.64 29.18 21.6 32.03 24.13 38.42 14.9 35.09'
            },
            {tagName: 'polygon', nameSpace: 'svg'}
        );
        createElWithAttrs(
            loaderGroupEyes, {
                id: 'eye-dx',
                points: '40.48 38.4 43.31 32.03 52.96 29.19 49.71 35.09 40.48 38.4'
            },
            {tagName: 'polygon', nameSpace: 'svg'}
        );
        createElWithAttrs(
            loaderGroupFace,
            {
                class: 'loader-indicator__path',
                d: clipPathValue
            },
            {tagName: 'path', nameSpace: 'svg'}
        );
    }

    if (message) {
        createElWithAttrs(loaderEl, {class: 'loader-message'}, 'p', message);
    } else {
        //If loaderEl already exists, and it has a message but the new Lodader invocation has none,
        //then delete the message element to prevent displaying the previeous message.
        let messageEl = loaderEl.querySelector('.loader-message');

        if (messageEl) {
            loaderEl.removeChild(messageEl);
        }
    }

    if (setAlt) {
        loaderEl.classList.add('set--alt');
    } else {
        loaderEl.classList.remove('set--alt');
    }

    //loader element is sometimes moved around the DOM,
    //this toggles the set--fixed class when no containerEl is provided.
    if (!containerEl) {
        loaderEl.classList.add('set--fixed');
    } else {
        loaderEl.classList.remove('set--fixed');
    }

    targetEl.appendChild(loaderEl);
    loaderEl.classList.add('set--visible');

    return loaderEl;
}

/**
 * @function
 * @description Hides an AJAX-loader
 */
export function hideLoader() {
    if (loaderEl) {
        loaderEl.classList.remove('set--visible');
    }
}
